import React from 'react';
const stats = [{
  value: '+12K',
  label: 'Entrenadores y profesores en la comunidad 🌎'
}, {
  value: '500+',
  label: 'Clubes y escuelas usan este sistema'
}, {
  value: '180K+',
  label: 'Sesiones y drills descargados este año'
}, {
  value: '92%',
  label: 'Ahorra 6h+ de planificación semanal'
}];
export function TrustBar() {
  return <section className="w-full bg-bg-alt py-10 sm:py-14 border-y border-border-light px-4 relative overflow-hidden" data-id="element-275">
      {/* Subtle gradient overlay */}
      <div className="absolute inset-0 bg-gradient-to-r from-transparent via-primary/5 to-transparent" data-id="element-276"></div>

      <div className="max-w-6xl mx-auto relative z-10" data-id="element-277">
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-6 sm:gap-8" data-id="element-278">
          {stats.map((stat, i) => <div key={i} className="text-center px-2 sm:px-4 border-r border-border-light/50 last:border-r-0 even:border-r-0 lg:even:border-r lg:last:border-r-0" data-id="element-279">
              <div className="text-primary font-black text-3xl sm:text-5xl tracking-tight drop-shadow-[0_0_15px_rgba(59,130,246,0.4)] mb-2" data-id="element-280">
                {stat.value}
              </div>
              <p className="text-text-sec text-xs sm:text-sm leading-tight font-medium" data-id="element-281">
                {stat.label}
              </p>
            </div>)}
        </div>

        {/* Standards badge */}
        <div className="mt-10 sm:mt-12 max-w-3xl mx-auto bg-bg-dark/50 backdrop-blur-sm border border-border-light rounded-2xl p-5 sm:p-6" data-id="element-282">
          <p className="text-text-main font-bold text-sm sm:text-base text-center mb-4 tracking-wider uppercase" data-id="element-283">
            Estándar profesional
          </p>
          <ul className="space-y-2.5 sm:space-y-2 text-text-sec text-sm sm:text-base" data-id="element-284">
            <li className="flex items-start gap-2" data-id="element-285">
              <span className="text-check-green flex-shrink-0" data-id="element-286">✓</span>
              <span data-id="element-287">
                Diseñado bajo criterios tácticos y pedagógicos modernos.
              </span>
            </li>
            <li className="flex items-start gap-2" data-id="element-288">
              <span className="text-check-green flex-shrink-0" data-id="element-289">✓</span>
              <span data-id="element-290">
                Apto para niveles Iniciación, Desarrollo y Competición.
              </span>
            </li>
            <li className="flex items-start gap-2" data-id="element-291">
              <span className="text-check-green flex-shrink-0" data-id="element-292">✓</span>
              <span data-id="element-293">
                Compatible con tablet, móvil, PC y listo para imprimir.
              </span>
            </li>
          </ul>
        </div>
      </div>
    </section>;
}